import React from 'react';

export default class TableForm extends React.Component {

	renderTable() {
		return (<table className="form">
			<tbody>
			{this.props.children}
			</tbody>
		</table>);
	}

	render() {
		if (this.props.className) {
			return (<div className={this.props.className}>
				{this.renderTable()}
			</div>)
		}
		return (
			this.renderTable()
		)
	}
}


// WEBPACK FOOTER //
// ./src/components/TableForm.js